


















import Vue from "vue";
import Component from "vue-class-component";
import NumberInput from "@/components/common/NumberInput.vue";
import { Prop, Emit } from "vue-property-decorator";
import { PulldownItem, getInnerTax } from "@/types";

@Component({
  components: {
    NumberInput
  }
})
export default class InvoiceOutBurden extends Vue {
  @Prop() item!: string;
  @Prop() unit_price!: number;
  @Prop() unit_num!: number;
  @Prop() total_money!: number;
  @Prop() tax!: number;
  @Prop() tax_money!: number;
  @Prop() tax_rate_items!: PulldownItem[];

  get Item() {
    return this.item;
  }
  set Item(newValue) {
    this.updateItem(newValue);
  }

  get UnitPrice() {
    return this.unit_price;
  }
  set UnitPrice(newValue) {
    this.updateUnitPrice(newValue);
    if (this.UnitNum != 0) {
      this.TotalMoney = newValue * this.UnitNum;
    }
  }

  get UnitNum() {
    return this.unit_num;
  }
  set UnitNum(newValue) {
    this.updateUnitNum(newValue);
    if (this.UnitPrice != 0) {
      this.TotalMoney = this.UnitPrice * newValue;
    }
  }

  get TotalMoney() {
    return this.total_money;
  }
  set TotalMoney(newValue) {
    this.updateTotalMoney(newValue);
    if (this.Tax != 0) {
      this.TaxMoney = getInnerTax(newValue, this.Tax);
    } else {
      this.updateTotalOuts();
    }
  }

  get Tax() {
    return this.tax;
  }
  set Tax(newValue) {
    this.updateTax(newValue);
    if (this.TotalMoney != 0) {
      this.TaxMoney = getInnerTax(this.TotalMoney, newValue);
    }
  }

  get TaxMoney() {
    return this.tax_money;
  }
  set TaxMoney(newValue) {
    this.updateTaxMoney(newValue);
    this.updateTotalOuts();
  }

  @Emit("update:item")
  private updateItem(newValue: unknown) {
    return newValue;
  }

  @Emit("update:unit_price")
  private updateUnitPrice(newValue: unknown) {
    return newValue;
  }

  @Emit("update:unit_num")
  private updateUnitNum(newValue: unknown) {
    return newValue;
  }

  @Emit("update:total_money")
  private updateTotalMoney(newValue: unknown) {
    return newValue;
  }

  @Emit("update:tax")
  private updateTax(newValue: unknown) {
    return newValue;
  }

  @Emit("update:tax_money")
  private updateTaxMoney(newValue: unknown) {
    return newValue;
  }

  @Emit("deleteItem")
  private deleteItem() {
    return;
  }

  @Emit("updateTotalOuts")
  private updateTotalOuts() {
    return;
  }
}
